import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

import { useShareHeadline } from '../../../../hooks/shareHeadline';

export const DEFAULT_PHOTO = { url: 'https://static.change.org/images/default-petition.gif', width: 1120, height: 630 };

type UseMetaImageTags = ModelHookResult<{
	ogImage: string;
	ogImageWidth: string;
	ogImageHeight: string;
	ogTwitterImage: string;
}>;

export function useMetaImageOgTags(): UseMetaImageTags {
	const {
		data: {
			petition: { photo },
		},
	} = usePetitionDetailsPageData();
	const { resolveUrl } = useUtilityContext();
	const shareHeadline = useShareHeadline();

	const metaPhoto = photo?.petitionLarge || DEFAULT_PHOTO;
	const imageUrl = resolveUrl(metaPhoto.url);

	// TODO: for images stored by Change, we should use the resolveUrl function to ensure the URL is correct
	// meantime we can use the imageUrl directly to support any image URL
	const shareImageUrl = shareHeadline?.imageUrl;

	return {
		data: {
			ogImage: shareImageUrl || imageUrl,
			// TODO: we should use a static width and height for the custom image created by Change
			ogImageWidth: `${metaPhoto.width}`,
			ogImageHeight: `${metaPhoto.height}`,
			ogTwitterImage: imageUrl,
		},
	};
}
